class Autocomplete {
    constructor(input, options) {
        this.input = $(input);
        this.input.attr('autocomplete', 'off');
        this.options = $.extend({}, $.fn.autocomplete.defaults, options);
        this.url = this.options.url || this.input.data('autocomplete-src');
        this.options.autoSelectFirst = this.options.autoSelectFirst || this.input.data('autocomplete-autoselectfirst');
        this.results = [];

        this.container = $('<div class="autocomplete-container"/>');
        this.list = $('<ul class="autocomplete-list"/>').appendTo(this.container);

        this.input.on('input', this.onInput.bind(this));
        this.input.on('blur', this.hide.bind(this));
        this.input.on('focus', this.show.bind(this));
        this.input.on('keydown', this.onKeyDown.bind(this));

        this.includes = [];
        this.options.include.push('token');
        let dataIncludes = this.input.data('autocomplete-include');
        if (dataIncludes) {
            for (let include of dataIncludes.trim().split(' ')) {
                this.options.include.push(include);
            }
        }
        for (let include of this.options.include) {
            if (typeof include === 'string') include = $('input[name="' + include + '"],select[name="' + include + '"],textarea[name="' + include + '"]');
            else include = $(include);
            if (include.length > 0) this.includes.push(include);
        }
    }

    onInput() {
        this.show();
        if (this.inputTimeout) clearTimeout(this.inputTimeout);
        if (this.input.val().length === 0) {
            this.results = [];
            this.determineVisibility();
        } else {
            this.container.addClass('loading');
            this.inputTimeout = setTimeout(this.refresh.bind(this), this.options.delay);
        }
    }

    refresh() {
        var data = { q: this.input.val() };
        if (data.q.length === 0) {
            this.results = [];
            this.determineVisibility();
        } else {
            if ($.csrfToken) data.token = $.csrfToken;
            for (let include of this.includes) data[include.attr('name')] = include.val();
            $.ajax({
                url: this.url,
                type: 'POST',
                data: data,
                dataType: 'json',
                success: this.refreshSuccess.bind(this),
                error: this.refreshError.bind(this)
            })
        }
    }

    refreshSuccess(data) {
        this.container.removeClass('loading');
        this.results = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i] != this.input.val()) this.results.push(data[i]);
        }
        this.updateList();
        this.determineVisibility();
        if (this.options.autoSelectFirst) {
            let li = this.list.find('li').first();
            if (li.length > 0 && this.results.length > 0) {
                this.focusLi(li);
                if (this.input[0] === document.activeElement) {
                    let suggestion = this.results[0];
                    let caret = this.input[0].selectionStart;
                    let value = this.input.val().substring(0, caret);
                    if (value.toLowerCase() === suggestion.substring(0, caret).toLowerCase()) {
                        value += suggestion.substring(caret);
                        this.input.val(value)[0].setSelectionRange(caret, value.length);
                    }
                }
            }
        }
    }

    refreshError(data) {
        this.container.removeClass('loading');
    }

    show() {
        if (this.input[0] !== document.activeElement) return;
        if (this.removeTimeout) clearTimeout(this.removeTimeout);
        if (this.container.hasClass('visible')) return;

        this.container.addClass('visible').insertAfter(this.input);
        if (this.input.val().length === 0) {
            this.results = [];
            this.updateList();
        }
        this.determineVisibility();
    }

    hide() {
        this.container.removeClass('visible');
        this.removeTimeout = setTimeout(this.container.remove.bind(this.container), 300);
        this.list.find('li.focus').removeClass('focus');
    }

    determineVisibility() {
        this.container.toggleClass('no-query', this.input.val().length === 0);
        this.container.toggleClass('no-results', this.results.length === 0);
    }

    updateList() {
        var results = this.results.slice();
        if (results.length === 0) return; // We're hiding through css instead
        this.list.find('li').each((i, li)=>{
            var self = $(li);
            var index = results.indexOf(self.text());
            if (index > -1) results.splice(index, 1);
            else self.remove();
        });
        for (var i = 0; i < results.length; i++) {
            var result = results[i];
            var li = $('<li/>').text(result).appendTo(this.list);
            li.on('mousedown', this.onLiMouseDown.bind(this, li));
            li.on('mouseenter', this.onLiMouseEnter.bind(this, li));
            li.on('mouseleave', this.onLiMouseLeave.bind(this, li));
            li.on('click', this.onLiClick.bind(this, li));
        }
        this.determineVisibility();
    }

    selectSuggestion(string) {
        this.input.val(string).blur();
        if (this.options.onSelect) this.options.onSelect();
        this.input.trigger('change').trigger('input');
    }

    focusLi(li, changeValue) {
        if (li.length > 0) {
            li.addClass('focus');
            li.siblings('.focus').removeClass('focus');
            if (changeValue) {
                this.input.val(li.text());
            }
        }
    }

    isVisible() {
        return this.container.hasClass('visible')
            && !this.container.hasClass('no-results')
            && !this.container.hasClass('no-query')
    }

    onKeyDown(event) {
        switch (event.key) {
            case $.key.return:
                var li = this.list.find('li.focus');
                if (this.isVisible() && li.length > 0) {
                    this.selectSuggestion(li.text());
                } else if (this.input.val().length > 0) {
                    this.selectSuggestion(this.input.val());
                }
                break;

            case $.key.up:
                var prev = this.list.find('.focus');
                if (prev.length > 0) prev = prev.prev('li');
                if (prev.length === 0) prev = this.list.find('li').last();
                this.focusLi(prev, true);
                break;

            case $.key.down:
                var next = this.list.find('.focus');
                if (next.length > 0) next = next.next('li');
                if (next.length === 0) next = this.list.find('li').first();
                this.focusLi(next, true);
                break;

            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
    }

    onLiMouseEnter(li) {
        this.focusLi(li);
    }

    onLiMouseLeave(li) {
        li.removeClass('focus');
    }

    onLiMouseDown(li, event) {
        event.preventDefault();
        event.stopPropagation();
    }

    onLiClick(li) {
        this.selectSuggestion(li.text());
    }
}

// jQuery helper

$.fn.autocomplete = function(options) {
    this.each(function(){
        return new Autocomplete(this, options);
    });
    return this;
}

$.fn.autocomplete.defaults = {
    // URL to where to send queries. Default: get from data-autocomplete attribute.
    url: false,
    // Callback to fire after suggestion selection
    onSelect: null,
    // Milliseconds to wait before fetching suggestions
    delay: 400,
    // Auto select first suggestion
    autoSelectFirst: false,
    // Input elements or names of other inputs to pass along with queries
    include: []
};

$('input[data-autocomplete-src]').autocomplete();
